const scriptRegex = /<script|(\Won\w+)=|javascript:/

const mkdStringToHtml = (el, bindings) => {
  const val = bindings.value || ''
  if (scriptRegex.test(val)) {
    return el
  }
  el.innerHTML = val
  return el
}

const SafeHtml = {
  beforeMount (el, bindings, vnode) {
    mkdStringToHtml(el, bindings)
  },
  updated (el, bindings) {
    mkdStringToHtml(el, bindings)
  }
}

export const SafeHtmlPlugin = {
  install (Vue, options) {
    Vue.directive('safe-html', SafeHtml)
  }
}
